module.exports = __webpack_public_path__ + "img/mobile-bg-image.f641efd9.png";